import Vue from 'vue';
import { default as StoreSetup } from '../Helper/StoreSetup';
import SearchMaskContainer from "FilterBar/BaseFilterBar/Searchmask/SearchMaskContainer.vue";
Vue.config.productionTip = false;
var initializeSearchMask = function (isCMSPage) {
    if (isCMSPage === void 0) { isCMSPage = false; }
    StoreSetup.initializeSearchMask();
    var searchMaskContainer = document.getElementById('searchMask');
    //Modal.registerFlyoutClosingListener();
    if (searchMaskContainer !== null) {
        new Vue({
            render: function (h) { return h(SearchMaskContainer, { props: { isCMSPage: isCMSPage } }); },
        }).$mount('#searchMask');
    }
};
export default initializeSearchMask;
